export const CURRENCIES = [
  { code: 'INR', symbol: '₹',    rate: 1,      label: '₹ INR' },
  { code: 'USD', symbol: '$',    rate: 0.012,  label: '$ USD' },
  { code: 'AED', symbol: 'د.إ', rate: 0.044,  label: 'د.إ AED' },
];

export function fmtPrice(inrAmount, currencyIndex = 0) {
  const c = CURRENCIES[currencyIndex] || CURRENCIES[0];
  const converted = Math.round(inrAmount * c.rate);
  return c.symbol + converted.toLocaleString('en-IN');
}

// alias — both names work
export const fmtCurrency = fmtPrice;